<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-text-field
          dense
          data-cy="FormLineItem-description"
          :label="$$t('description')"
          v-model="localLineItem.description"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-quantity"
          :label="$$t('quantity')"
          v-model="localLineItem.quantity"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-unitAmount"
          :label="$$t('unitAmount')"
          v-model="localLineItem.unitAmount"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-accountCode"
          :label="$$t('accountCode')"
          v-model="localLineItem.accountCode"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-lineItemID"
          :label="$$t('lineItemID')"
          v-model="localLineItem.lineItemID"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-taxType"
          :label="$$t('taxType')"
          v-model="localLineItem.taxType"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-taxAmount"
          :label="$$t('taxAmount')"
          v-model="localLineItem.taxAmount"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-lineAmount"
          :label="$$t('lineAmount')"
          v-model="localLineItem.lineAmount"
        />
        <v-text-field
          dense
          data-cy="FormLineItem-discountRate"
          :label="$$t('discountRate')"
          v-model="localLineItem.discountRate"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormLineItem-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormLineItem-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormLineItem',
  module: 'LineItem',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    LineItem: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localLineItem
      */
      localLineItem: {},
    };
  },
  watch: {
    LineItem() {
      this.localLineItem = this.LineItem;
    },
  },
  created() {
    this.localLineItem = this.LineItem;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localLineItem);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormLineItem example

'''js
<FormLineItem :LineItem="LineItem" />
'''
</docs>
